<template>
  <v-container class="admin-login-container" fluid>
    <v-snackbar v-model="alert.show" top :color="alert.type || 'error'" dark :timeout="alert.ts || 5000">
      [提示] {{ alert.msg }} ~~
      <v-btn dark flat @click="alert.show = false">关闭</v-btn>
    </v-snackbar>
    <v-layout align-center justify-start column>
      <v-flex class="top-logo">
        <img v-if="tenant.logo" class="logo" :src="tenant.logo" />
        <img v-else class="logo" src="@/assets/logo-w.png" />
      </v-flex>
      <div class="top-title">
        <h2>{{ tenant.appName || appname }}</h2>
        <h3 v-if="!tenant.appName">{{ slogan }}</h3>
      </div>
      <v-flex>
        <v-card class="admin-login">
          <v-tabs v-model="active">
            <v-tab>密码登录</v-tab>
            <v-tab>手机验证码登录</v-tab>
            <v-tab-item>
              <v-form v-model="form.valid" ref="form">
                <v-text-field validate-on-blur label="手机号/登录名" v-model="form.username" :rules="rules.required" required
                  @change="onUsernameChange"></v-text-field>
                <v-select v-if="orgs && orgs.length > 1" v-model="org" :items="orgs" label="选择机构" item-text="name"
                  :return-object="true"></v-select>
                <v-text-field label="密码" required validate-on-blur v-model="form.password" :rules="rules.required"
                  :append-icon="passwordShow ? 'visibility' : 'visibility_off'"
                  :type="passwordShow ? 'text' : 'password'" @click:append="passwordShow = !passwordShow">
                </v-text-field>
                <v-text-field validate-on-blur label="验证码" :rules="rules.captcha" required v-model="form.captcha"
                  @keyup.enter="submit(1)">
                  <img class="captcha" slot="append" :src="captchaUrl" @click.stop="refreshCaptchaUrl" />
                  <span class="captcha-link" slot="append-outer" @click.stop="refreshCaptchaUrl">看不清?</span>
                </v-text-field>
                <v-btn block color="primary" @click.prevent="submit(1)" class="my-0">登录</v-btn>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <v-form v-model="form2.valid" ref="form2">
                <v-text-field validate-on-blur label="手机号" v-model="form2.username" :rules="rules.mobile" required
                  @change="onMobileChange"></v-text-field>
                <v-select v-if="orgs2 && orgs2.length > 1" v-model="org2" :items="orgs2" label="选择机构" item-text="name"
                  :return-object="true"></v-select>
                <v-text-field validate-on-blur label="验证码" :rules="rules.captcha" required v-model="form2.captcha">
                  <img v-if="captchaUrl2" class="captcha" slot="append" :src="captchaUrl2"
                    @click.stop="refreshCaptchaUrl" />
                  <span class="captcha-link" slot="append-outer" @click.stop="refreshCaptchaUrl">看不清?</span>
                </v-text-field>
                <v-text-field validate-on-blur label="短信验证码" :rules="rules.required" required v-model="form2.code"
                  @keyup.enter="submit(2)">
                  <span class="code-link" slot="append" @click="onSendMsgInfo">{{ sendMsgInfo }}</span>
                </v-text-field>
                <v-btn block color="primary" @click.prevent="submit(2)" class="my-0">登录</v-btn>
              </v-form>
            </v-tab-item>
          </v-tabs>
          <v-btn block outline color="primary" v-if="autoLogin && token" @click.prevent="tokenSubmit" class="my-0 mt-3">
            自动登录</v-btn>
          <v-layout row justify-between v-if="lStore">
            <v-flex xs6>
              <v-checkbox class="remember" color="primary" label="下次自动登录" v-model="autoLogin" />
            </v-flex>
            <v-flex xs6>
              <v-btn block flat color="primary" style="margin-top: 12px" @click="$router.push('/register')"
                v-if="tenant.register">
                企业注册<v-icon>arrow_forward</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-btn block outline color="primary" style="margin-bottom: 12px" @click="$router.push('/register')"
            v-else-if="tenant.register">
            企业注册<v-icon>arrow_forward</v-icon>
          </v-btn>
        </v-card>
      </v-flex>
      <v-flex class="copyright">
        <p class="white--text my-0 mt-1 text-xs-center">
          &copy;2025 {{ tenant.copyrights || company }}
        </p>
        <p class="white--text my-0 mt-3 text-xs-center">
          <a href="https://beian.miit.gov.cn/" target="_blank" class="link">{{ tenant.icp
      || icp
            }}</a> | <span class="link">最近更新: {{ version }}</span> | <a class="link"
            href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank">推荐浏览器下载</a>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CanvasNest from "canvas-nest.js";
let cn;
const REG_M = /^1[3-9]\d{9}$/,
  REG_C = /[\d\w]{4}/;

export default {
  name: "admin-login",
  data() {
    return {
      sendMsgInfo: "发送验证码",
      active: 0,
      captchaUrl: this.$const.baseUrl + "/p/captcha.png?" + Date.now(),
      captchaUrl2: null,
      appname: this.$const.appName,
      slogan: this.$const.slogan,
      company: this.$const.company,
      version: this.$const.version,
      icp: this.$const.icp,
      lStore: null,
      autoLogin: false,
      token: null,
      passwordShow: false,
      form: {
        valid: false,
        username: "",
        password: "",
        captcha: "",
      },
      form2: {
        valid: false,
        username: "",
        code: "",
        captcha: "",
      },
      rules: {
        mobile: [(v) => REG_M.test(v) || "手机号不正确"],
        required: [(v) => !!v || "必须填写"],
        captcha: [(v) => REG_C.test(v) || "验证码不正确"],
      },
      orgs: null,
      org: null,
      orgs2: null,
      org2: null,
    };
  },
  computed: {
    tenant() {
      return this.$store.state.tenant;
    },
    alert() {
      return this.$store.state.alert;
    },
    dark() {
      return this.$store.state.dark;
    },
  },
  mounted() {
    cn = new CanvasNest(document.querySelector("body"), {
      color: "255,255,255",
      pointColor: "255,255,255",
      count: 88,
      opacity: 0.8,
      zIndex: 0,
    });
  },
  beforeDestroy() {
    cn && cn.destroy();
  },
  watch: {
    active() {
      this.refreshCaptchaUrl();
    },
    autoLogin(n) {
      if (!this.lStore) {
        return;
      }
      if (n) {
        this.lStore.setItem("__autologin", true);
      } else {
        this.lStore.removeItem("__autologin");
      }
    },
  },
  methods: {
    onSendMsgInfo() {
      let self = this;
      if (self._counter > 0) {
        return;
      }
      if (!REG_M.test(self.form2.username) || !REG_C.test(self.form2.captcha)) {
        return;
      }
      self._counter = 60;
      self._interval = setInterval(() => {
        self._counter = self._counter - 1;
        if (self._counter <= 0) {
          clearInterval(self._interval);
          self.sendMsgInfo = "发送验证码";
        } else {
          self.sendMsgInfo = `${self._counter}秒`;
        }
      }, 1000);
      //发送
      let t = self.tenant,
        params = { mobile: self.form2.username, captcha: self.form2.captcha },
        tid = self.org2 ? self.org2.tid : (t ? t.id : null);
      if (tid !== null) {
        params.__tid = tid;
      }
      if (self.org2) {
        params.__oid = self.org2.oid;
      }

      self.$axios
        .get(
          '/p/sm/send/2', { params: params }
        )
        .then((r) => {
          if (r.data.status != "ok") {
            clearInterval(self._interval);
            self._counter = 0;
            self.refreshCaptchaUrl();
            self.$status((r.data.message || '发送短信验证码失败') + '  请重试');
          }
        });
    },
    onMobileChange() {
      let self = this,
        tenant = self.tenant;
      if (self.form2.username) {
        self.org2 = null;
        self.orgs2 = null;
        self.$axios
          .get("/p/a/q", {
            params: {
              un: self.form2.username,
              tid: tenant.id,
              //oid: tenant.orgId,
            },
          })
          .then((r) => {
            if (r.data && r.data.status == "ok" && r.data.message) {
              self.orgs2 = r.data.message;
            }
          });
      }
    },
    onUsernameChange() {
      let self = this,
        tenant = self.tenant;
      if (self.form.username) {
        self.org = null;
        self.orgs = null;
        self.$axios
          .get("/p/a/q", {
            params: {
              un: self.form.username,
              tid: tenant.id,
              //oid: tenant.orgId,
            },
          })
          .then((r) => {
            if (r.data && r.data.status == "ok" && r.data.message) {
              self.orgs = r.data.message;
            }
          });
      }
    },
    refreshCaptchaUrl() {
      if (this.active == 0) {
        this.captchaUrl = this.$const.baseUrl + "/p/captcha.png?" + Date.now();
        this.form.captcha = "";
      } else {
        this.captchaUrl2 = this.$const.baseUrl + "/p/captcha.png?" + Date.now();
        this.form2.captcha = "";
      }
    },
    tokenSubmit() {
      let self = this;
      if (!self.token) {
        return;
      }
      self.$axios
        .get("/login", { params: { _t: 2, token: self.token } })
        .then((r) => {
          if (r && r.data && r.data.status === "ok") {
            let a = r.data.message;
            if (self.lStore) {
              if (self.autoLogin) {
                self.token = a.token;
                self.lStore.setItem(
                  "__token",
                  `${a.tenantId}/${a.orgId}/${a.token}`
                );
              }
              self.lStore.setItem(
                "__username",
                `${a.tenantId}/${a.orgId}/${self.form.username}`
              );
            }
            self.$store.commit("account", a);
            self.$router.push("/console");
          }
        })
        .catch(() => {
          self.token = null;
          if (self.lStore) {
            self.lStore.removeItem("__token");
          }
        });
    },
    submit(type) {
      let self = this,
        form = type == 1 ? self.form : self.form2,
        formRef = type == 1 ? self.$refs.form : self.$refs.form2,
        orgs = type == 1 ? self.orgs : self.orgs2,
        org = type == 1 ? self.org : self.org2;
      if (!formRef.validate()) {
        return
      }
      if (form.valid) {
        let data = { _t: 1, ...form },
          tenant = self.tenant;
        if (orgs && orgs.length > 1) {
          if (!org) {
            return;
          }
          data._tid = org.tid;
          data._oid = org.oid;
        } else {
          data._tid = tenant.id;
          //data._oid = tenant.orgId;
        }
        self.$axios
          .post("/login", self.$qs.stringify(data))
          .then((r) => {
            if (r && r.data && r.data.status === "ok") {
              let a = r.data.message;
              if (self.lStore) {
                if (self.autoLogin) {
                  self.token = a.token;
                  self.lStore.setItem(
                    "__token",
                    `${a.tenantId}/${a.orgId}/${a.token}`
                  );
                }
                self.lStore.setItem(
                  "__username",
                  `${a.tenantId}/${a.orgId}/${form.username}`
                );
              }
              self.$store.commit("account", a);
              self.$router.push("/console");
            } else {
              self.refreshCaptchaUrl();
            }
          })
          .catch((err) => {
            //[40005]表示需要手机号登录.
            if (
              err.response.data &&
              err.response.data.message &&
              err.response.data.message.indexOf("[40005]") != -1
            ) {
              self.active = 1;
            }
            self.refreshCaptchaUrl();
          });
      }
    },
  },
  created() {
    if (typeof localStorage === "object") {
      let ls = (this.lStore = localStorage);
      let un = ls.getItem("__username"),
        autoLogin = ls.getItem("__autologin"),
        tenant = this.tenant;
      if (un) {
        //un=tid/oid/username
        let tmp = un.split("/");
        if (
          tmp.length == 3 &&
          (!tenant.id || tmp[0] == tenant.id) &&
          (!tenant.orgId || tmp[1] == tenant.orgId)
        ) {
          this.form.username = tmp[2];
          this.onUsernameChange();
        }
      }
      if (autoLogin) {
        this.autoLogin = true;
        //token=tid/oid/token
        let token = ls.getItem("__token");
        if (token) {
          let tmp = token.split("/");
          if (
            tmp.length == 3 &&
            (!tenant.id || tmp[0] == tenant.id) &&
            (!tenant.orgId || tmp[1] == tenant.orgId)
          ) {
            this.token = tmp[2];
          }
        }
      }
    }
  },
};
</script>

<style scoped>
.admin-login-container {
  background: var(--v-primary-base) url("../assets/login.png") center bottom no-repeat;
  position: relative;
  flex-grow: 0;
}

.admin-login-container .top-logo {
  flex-grow: 0;
  margin-top: 36px;
  display: inline-flex;
}

.admin-login-container .top-logo img {
  width: auto;
  height: 30px;
}

.admin-login-container .copyright {
  flex-grow: 0;
  margin-top: 16px;
}

.admin-login-container .copyright .link {
  padding: 8px 0;
  color: #fff;
  text-decoration: none;
}

.admin-login-container .top-title h2 {
  text-align: center;
  color: white;
  font-size: 24px;
  margin: 8px 0;
}

.admin-login-container .top-title h3 {
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: normal;
  margin: 8px 0;
}

.admin-login {
  max-width: 450px;
  text-align: center;
  padding: 40px 65px;
  margin-top: 40px;
}

.admin-login img.logo {
  max-width: 100px;
}

.admin-login form {
  margin-top: 40px;
}

.admin-login form .remember {
  margin-top: 0;
}

.admin-login img.captcha {
  width: 120px;
  cursor: pointer;
}

.admin-login .captcha-link {
  font-size: 10px;
  display: inline-block;
  cursor: pointer;
  width: 45px;
  line-height: 40px;
  text-align: right;
}

.admin-login .code-link {
  font-size: 10px;
  display: inline-block;
  cursor: pointer;
  width: 60px;
  line-height: 40px;
  text-align: center;
}

@media screen and (max-height: 800px) {
  .admin-login-container .top-logo {
    margin-top: 10px;
  }

  .admin-login {
    margin-top: 20px;
  }

  .admin-login-container {
    background-size: 50%;
  }
}

.ver {
  padding: 8px;
}
</style>
